import React, { useEffect, useState } from "react";
import LogoutButton from "../Buttons/logout";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardIcon from "../../Assets/Svg/dashboard";
import ProductIcon from "../../Assets/Svg/products";
import BillingIcon from "../../Assets/Svg/billing";
import InventoryIcon from "../../Assets/Svg/inventory";
import SalesIcon from "../../Assets/Svg/sales";
import PurchaseIcon from "../../Assets/Svg/purchase";
import CustomerIcon from "../../Assets/Svg/customer";
import SupplierIcon from "../../Assets/Svg/supplier";
import ReportIcon from "../../Assets/Svg/reports";
import ExpenseIcon from "../../Assets/Svg/expense";
import SettingIcon from "../../Assets/Svg/settings";
import ImportexpoertIcon from "../../Assets/Svg/importexport";
import AccountingIcon from "../../Assets/Svg/accouting";
import ExpandMoreIcon from "../../Assets/Svg/expand_more";
import PremiumIcon from "../../Assets/Svg/premiumIcon";

const Sidebar = ({ body }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});
  const [data, setData] = useState([]);
  const plan = body?.branch?.plan;

  useEffect(() => {
    if (!body?.role) return;
    const baseMenu = [
      { icon: <DashboardIcon />, name: "Dashboard", path: "/app/dashboard" },
      { icon: <ProductIcon />, name: "Products", path: "/app/products" },
      { icon: <ProductIcon />, name: "Services", path: "/app/services" },
      { icon: <InventoryIcon />, name: "Inventory", path: "/app/inventory" },
      { icon: <BillingIcon />, name: "Billing", path: "/app/billing" },
      { icon: <SalesIcon />, name: "Sales", path: "/app/sales" },
      { icon: <PurchaseIcon />, name: "Purchases", path: "/app/purchases" },
      { icon: <ExpenseIcon />, name: "Expenses", path: "/app/expenses" },
      { icon: <CustomerIcon />, name: "Customers", path: "/app/customers" },
      { icon: <SupplierIcon />, name: "Suppliers", path: "/app/suppliers" },
      {
        icon: <AccountingIcon />,
        name: "Accounting",
        path: "/app/accounting",
        subMenu: [
          {
            name: "Chart of Accounts",
            path: "/app/accounting/chart-of-accounts",
          },
          { name: "Journal Entries", path: "/app/accounting/manual-journals" },
        ],
      },
      {
        icon: <ReportIcon />,
        name: "Financial Reports",
        path: "/app/common/reports",
      },
      { icon: <ReportIcon />, name: "Reports", path: "/app/reports" },
      {
        icon: <ImportexpoertIcon />,
        name: "Import-Export",
        path: "/app/importexport",
      },
      { icon: <SettingIcon />, name: "Settings", path: "/app/settings" },
    ];

    if (body?.role === "SUPERADMIN") {
      setData(baseMenu);
    } else {
      const allowed = [];
      const optionNames = baseMenu.map((m) => m.name);

      body?.role?.details?.forEach((perm) => {
        if (perm?.view && optionNames.includes(perm.name)) {
          const idx = optionNames.indexOf(perm.name);
          allowed.push(baseMenu[idx]);
        }
      });

      setData(allowed);
    }
  }, [body]);

  const toggleSubMenu = (name) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const handleMenuClick = (value) => {
    const isPremiumRestricted =
      plan === 403 &&
      (value.name === "Accounting" || value.name === "Financial Reports");

    if (value.subMenu) toggleSubMenu(value.name);
    if (isPremiumRestricted) return;
    if (!value.subMenu) navigate(value.path);
  };

  return (
    <div className="border-r bg-white fixed left-0 top-0 bottom-0 z-50 w-64">
      <div className="p-4 overflow-y-auto h-full">
        <div className="mt-16">
          {data.map((value, index) => {
            const isPremiumRestricted =
              plan === 403 &&
              (value.name === "Accounting" ||
                value.name === "Financial Reports");

            return (
              <div key={index}>
                <div
                  className={`my-2 cursor-pointer ${location?.pathname?.includes(value?.path)
                    ? "bg-[#6254be] rounded-lg"
                    : ""
                    }`}
                  onClick={() => handleMenuClick(value)}
                >
                  <div
                    className={`flex p-2 items-center ${location?.pathname?.includes(value?.path)
                      ? "text-white"
                      : isPremiumRestricted
                        ? "text-gray-400"
                        : "text-[#353F4F] hover:text-[#6254be]"
                      }`}
                  >
                    <div>{value.icon}</div>
                    <div className="px-2 flex-1">{value.name}</div>

                    {value.subMenu && (
                      <ExpandMoreIcon
                        className={`transition-transform ${expandedMenus[value.name] ? "rotate-180" : ""
                          }`}
                      />
                    )}

                    {isPremiumRestricted && (
                      <div className="ml-2">
                        <PremiumIcon />
                      </div>
                    )}
                  </div>
                </div>

                {/* 🔹 Submenu Section */}
                {value.subMenu && expandedMenus[value.name] && (
                  <div className="pl-8">
                    {value.subMenu.map((sub, i) => {
                      const isSubPremiumRestricted =
                        plan === 403 && value.name === "Accounting";
                      return (
                        <div
                          key={i}
                          className={`my-2 flex items-center ${isSubPremiumRestricted
                            ? "text-gray-400 cursor-not-allowed"
                            : location?.pathname?.includes(sub.path)
                              ? "bg-[#6254BE] rounded-lg text-white"
                              : "text-[#353F4F] hover:text-[#6254BE] cursor-pointer"
                            }`}
                          onClick={() => {
                            if (!isSubPremiumRestricted) navigate(sub.path);
                          }}
                        >
                          <div className="flex p-2 w-full items-center">
                            <div className="px-2 flex-1">{sub.name}</div>
                            {isSubPremiumRestricted && <PremiumIcon />}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="w-full absolute bottom-0 left-0">
        <LogoutButton />
      </div>
    </div>
  );
};

export default Sidebar;